module.exports = __webpack_public_path__ + "img/answerer.b347a9dc.png";